import { Component, effect, input, output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { AreaWithDetails } from "../../../../../../../domains/jobs/services/bq-inspection-data.service";
import { Area } from "../../../../../../../core/database/db";
import { Router, ActivatedRoute } from "@angular/router";
import { LocationAction } from "../locations-tab/locations-tab.component";
import { RadioButtonModule } from "primeng/radiobutton";

export interface NaStatusChangeEvent {
  areaId: number;
  isNa: boolean;
}

@Component({
  selector: "app-locations-area-card",
  standalone: true,
  imports: [CommonModule, FormsModule, RadioButtonModule],
  templateUrl: "./locations-area-card.component.html",
  styleUrls: ["./locations-area-card.component.scss"],
})
export class LocationsAreaCardComponent {
  area = input.required<AreaWithDetails>();
  isNewlyAdded = input(false);
  locationAction = input(LocationAction.Viewing);
  onToggleNaStatus = output<NaStatusChangeEvent>();

  LocationActionEnum = LocationAction;
  isMarkedNa = false;

  constructor(private router: Router, private route: ActivatedRoute) {
    effect(() => {
      const locationAction = this.locationAction();
      if (locationAction !== LocationAction.Viewing) {
        this.isMarkedNa = false;
      }
    });
  }

  getAreaUrl(areaId: number | undefined): string {
    if (areaId === undefined) {
      return "";
    }
    return this.router.serializeUrl(
      this.router.createUrlTree(["../../area", areaId], { relativeTo: this.route })
    );
  }

  onClickAssertions(area: Area, event?: MouseEvent): void {
    event?.preventDefault();
    this.router.navigate(["../../area", area.id], { relativeTo: this.route });
  }

  toggleNaStatus(areaId: number): void {
    this.isMarkedNa = !this.isMarkedNa;
    this.onToggleNaStatus.emit({ areaId, isNa: this.isMarkedNa });
  }
}